import styled from "@emotion/styled";

import photoStrip1 from "@/../../hypetrain/static/img/photo-strip-1.png";
import photoStrip2 from "@/../../hypetrain/static/img/photo-strip-2.png";
import { Box, Flex } from "@/components/layout/flexbox";
import { Media } from "@/components/layout/Media";
import { PUBLIC_CONTENT_MAX_WIDTH, STANDARD_NAV_HEIGHT } from "@/css/constants";

function DottedArrow({ style = {}, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      style={{ maxWidth: "100%", width: 466, ...style }}
      viewBox="0 0 466 146"
      {...props}
    >
      <path
        stroke="#3788EE"
        strokeDasharray="1 5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M.5 143.5h232.25m232.25 0H232.75m0 0V1m0 142.5L170 80.75m62.75 62.75 62.75-62.75"
      />
    </svg>
  );
}

interface ScrollPhotoProps {
  src: string;
  reversed?: boolean;
}

function ScrollPhoto({ src, reversed = false }: ScrollPhotoProps) {
  return (
    <Media greaterThan="sm">
      <Box className="relative" maxHeight={685} overflow="hidden">
        <ScrollImg src={src} className={reversed ? "reversed" : ""} />
      </Box>
    </Media>
  );
}

export function MainHero() {
  return (
    <Box backgroundColor="#FBFBFF" pt={STANDARD_NAV_HEIGHT}>
      <Flex
        width="100%"
        maxWidth={PUBLIC_CONTENT_MAX_WIDTH}
        mx="auto"
        justifyContent={["center", "center", "space-between"]}
        alignItems="center"
      >
        <ScrollPhoto src={photoStrip1} reversed={true} />
        <Flex
          flexDirection="column"
          alignItems="center"
          textAlign="center"
          width={550}
          maxWidth="100%"
        >
          <DottedArrow />
          <h1 className="my-8 font-serif text-6xl/tight font-light text-blue-900">
            We exist to
            <br />
            <i>scale excellence</i>
          </h1>
          <DottedArrow style={{ transform: "rotate(180deg)" }} />
        </Flex>
        <ScrollPhoto src={photoStrip2} />
      </Flex>
    </Box>
  );
}

const ScrollImg = styled.img`
  animation: aboutScroll 51s linear infinite;

  &.reversed {
    animation: aboutScrollReverse 51s linear infinite;
  }

  @keyframes aboutScroll {
    0% {
      transform: translateY(-90px);
    }
    50% {
      transform: translateY(-295px);
    }
    100% {
      transform: translateY(-90px);
    }
  }

  @keyframes aboutScrollReverse {
    0% {
      transform: translateY(-180px);
    }
    50% {
      transform: translateY(20px);
    }
    100% {
      transform: translateY(-180px);
    }
  }
`;
